import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6f5c501f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Business Details")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-row gap-2"
}
const _hoisted_5 = {
  key: 0,
  class: "card-body d-flex flex-column px-0 pt-0"
}
const _hoisted_6 = { class: "d-flex flex-row p-9" }
const _hoisted_7 = { class: "w-50 d-flex flex-column" }
const _hoisted_8 = { class: "d-flex flex-row mb-7" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Business Name", -1))
const _hoisted_10 = { class: "w-60" }
const _hoisted_11 = { class: "fw-bold fs-6" }
const _hoisted_12 = { class: "d-flex flex-row mb-7" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Office Number", -1))
const _hoisted_14 = { class: "w-60" }
const _hoisted_15 = { class: "fw-bold fs-6" }
const _hoisted_16 = { class: "d-flex flex-row mb-7" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Mobile Number", -1))
const _hoisted_18 = { class: "w-60" }
const _hoisted_19 = { class: "fw-bold fs-6" }
const _hoisted_20 = { class: "d-flex flex-row mb-7" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Email", -1))
const _hoisted_22 = { class: "w-60" }
const _hoisted_23 = { class: "fw-bold fs-6" }
const _hoisted_24 = { class: "d-flex flex-row mb-7" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Website", -1))
const _hoisted_26 = { class: "w-60" }
const _hoisted_27 = { class: "fw-bold fs-6" }
const _hoisted_28 = { class: "d-flex flex-row mb-7" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "ACN", -1))
const _hoisted_30 = { class: "w-60" }
const _hoisted_31 = { class: "fw-bold fs-6" }
const _hoisted_32 = { class: "d-flex flex-row mb-7" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "ABN", -1))
const _hoisted_34 = { class: "w-60" }
const _hoisted_35 = { class: "fw-bold fs-6" }
const _hoisted_36 = { class: "w-50 d-flex flex-column" }
const _hoisted_37 = { class: "d-flex flex-row mb-7" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Address Line", -1))
const _hoisted_39 = { class: "w-60" }
const _hoisted_40 = { class: "fw-bold fs-6" }
const _hoisted_41 = { class: "d-flex flex-row mb-7" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "City", -1))
const _hoisted_43 = { class: "w-60" }
const _hoisted_44 = { class: "fw-bold fs-6" }
const _hoisted_45 = { class: "d-flex flex-row mb-7" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "State", -1))
const _hoisted_47 = { class: "w-60" }
const _hoisted_48 = { class: "fw-bold fs-6" }
const _hoisted_49 = { class: "d-flex flex-row mb-7" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Postal Code", -1))
const _hoisted_51 = { class: "w-60" }
const _hoisted_52 = { class: "fw-bold fs-6" }
const _hoisted_53 = { class: "d-flex flex-row mb-7" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Country", -1))
const _hoisted_55 = { class: "w-60" }
const _hoisted_56 = { class: "fw-bold fs-6" }
const _hoisted_57 = { class: "d-flex flex-row mb-7" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Background Color", -1))
const _hoisted_59 = { class: "w-60" }
const _hoisted_60 = { class: "d-flex flex-row mb-7" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-40 fw-bold text-muted" }, "Text Color", -1))
const _hoisted_62 = { class: "w-60" }
const _hoisted_63 = {
  key: 1,
  class: "column container py-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessLogo = _resolveComponent("BusinessLogo")!
  const _component_BusinesProfileForm = _resolveComponent("BusinesProfileForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleEdit())),
              class: "btn align-self-center btn-new-design-primary"
            }, " Edit Business Profile ")
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "d-flex flex-column w-100 mb-7 justify-content-center text-center align-middle py-2",
            style: _normalizeStyle({
          minHeight: `60px`,
          background: _ctx.authUser.business_color ?? 'transparent',
          color: _ctx.authUser.business_text_color ?? '#ffffff',
        })
          }, [
            (_ctx.authUser.business_logo)
              ? (_openBlock(), _createBlock(_component_BusinessLogo, {
                  key: 0,
                  imageSrc: _ctx.getBusinessLogo,
                  fill: "scale-down"
                }, null, 8, ["imageSrc"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.authUser.business_name
              ? _ctx.$filters.ucwords(_ctx.authUser.business_name)
              : ''), 1)
                ], 64))
          ], 4),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.authUser.business_name
                    ? _ctx.$filters.ucwords(_ctx.authUser.business_name)
                    : ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$filters.formatPhone((_ctx.authUser || {}).business_phone_number)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$filters.formatMobile((_ctx.authUser || {}).business_mobile_number)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString((_ctx.authUser || {}).business_email_address), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString((_ctx.authUser || {}).business_website), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$filters.formatACN((_ctx.authUser || {}).acn)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$filters.formatABN((_ctx.authUser || {}).abn)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString((_ctx.authUser || {}).business_address_line), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, _toDisplayString((_ctx.authUser || {}).business_city), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.businessStateName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, _toDisplayString((_ctx.authUser || {}).business_post_code), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.businessCountryName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", {
                    class: "fw-bold w-50 fs-6",
                    style: _normalizeStyle({
                  height: `31px`,
                  border: `1px solid #cccccc`,
                  borderRadius: `5px`,
                  background: _ctx.authUser.business_color ?? `transparent`,
                })
                  }, "   ", 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", {
                    class: "fw-bold w-50 fs-6",
                    style: _normalizeStyle({
                  height: `31px`,
                  border: `1px solid #cccccc`,
                  borderRadius: `5px`,
                  background: _ctx.authUser.business_text_color ?? `transparent`,
                })
                  }, "   ", 4)
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_63, [
          _createVNode(_component_BusinesProfileForm, {
            businessProfile: _ctx.authUser,
            updateMode: _ctx.updateMode,
            formSubmitLoading: _ctx.formSubmitLoading,
            onEditMode: _ctx.handleEdit,
            onSaveBusinessProfile: _ctx.handleSaveBusinessProfile,
            onUpdateBusinessProfile: _ctx.handleUpdateBusinessProfile
          }, null, 8, ["businessProfile", "updateMode", "formSubmitLoading", "onEditMode", "onSaveBusinessProfile", "onUpdateBusinessProfile"])
        ]))
  ]))
}